/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReorderUnitPosAdditionalImagesRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ReorderUnitPosAdditionalImagesResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const reorderUnitPosAdditionalImages = (request: ReorderUnitPosAdditionalImagesRequest, options?: CashRequestOptions) => post<ReorderUnitPosAdditionalImagesRequest, ReorderUnitPosAdditionalImagesResponse>("/2.0/cash/reorder-unit-pos-additional-images", request, {...options, rejectOnError: true })